import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import GlobalErrorBoundary from "./components/GlobalErrorBoundary";
import "./index.css";
import "./styles/apple-globals.css";
import "./styles/apple-animations.css";
import "./styles/apple-responsive.css";
import "./styles/apple-accessibility.css";
import "./styles/apple-liquiglass-enhanced.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <GlobalErrorBoundary
      enableReporting={process.env.NODE_ENV === "production"}
      onError={(error, errorInfo, context) => {
        // Custom error handling logic
        console.error(
          `[${context}] Error caught by GlobalErrorBoundary:`,
          error,
          errorInfo,
        );
      }}
    >
      <App />
    </GlobalErrorBoundary>
  </StrictMode>,
);
